import DataAnalytics from "assets/img/landing/dashboard.png";
import DataManagement from "assets/img/landing/big-data.png";
import AIEngine from "assets/img/landing/android-bra.png";
import Image from "next/image";
import { useTranslation } from "react-i18next";

function index() {
  const { t, i18n } = useTranslation();

  return (
    <div className="py-15 px-5 xl:px-0 bg-[#F2F6EC]">
      <div className="container m-auto ">
        <div className="text-3xl font-bold text-center text-main">
          {t("DIGITAL SERVICES")}
        </div>
        <div className="flex flex-wrap items-center justify-center mt-15 md:flex-nowrap md:items-start md:justify-between gap-15">
          <div className="w-[400px] flex flex-col items-center justify-center gap-4">
            <Image
              width="114.96"
              height="112.51"
              src={DataAnalytics}
              quality={40}
              alt="img"
            />
            <div className="text-3xl font-bold text-center text-main">
              {t("Data Analytics")}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "PLATFARM enables decision-makers with data on an ongoing basis through the unit of reports and data by linking different types of data to each other and displaying them in a way that helps the decision-maker with a deeper understanding of the impact of various processes on plant health and linking them to expenses."
              )}
            </div>
          </div>
          <div className="w-[400px] flex flex-col items-center justify-center gap-4">
            <Image
              quality={40}
              width="114.96"
              height="112.51"
              src={DataManagement}
              alt="img"
            />
            <div className="text-3xl font-bold text-center text-main">
              {t("Data Management")}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "PLATFARM manages farm data and maps throughout the agricultural season, store it appropriately to be processed and accessed via the platform through the web interface and the phone application."
              )}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {i18n.language === "en" ? (
                <>
                  The data can be accessed whether during the agricultural
                  season or after the end of the season to benefit from previous
                  practices and study their results, make comparisons and better
                  planning for the new season to reach better productivity at
                  lower cost with the help of available data.
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="w-[400px] flex flex-col items-center justify-center gap-4">
            <Image
              quality={40}
              width="114.96"
              height="112.51"
              src={AIEngine}
              alt="img"
            />
            <div className="text-3xl font-bold text-center text-main">
              {t("AI Engine")}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "PLATFARM is empowered with an AI engine with a set of artificial intelligence tools that processes and analyzes data received from various sources such as drones, satellites, ground sensors, and daily activities on the farm, and then makes simplified reports on the daily status of the crop in each field."
              )}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "This engine also provides automated conversations with the platform through WhatsApp chats to provide a simpler way to access data. It identifies well-growth and late-growth sites within each field daily."
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
